/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './ReviewConfirmation.module.scss'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import BackAnchor from '../../../../shared/components/BackAnchor'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()

  const [errMsg, setErrMsg] = useState('')
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckboxMessage] = useState(false)
  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()

  const userIdentifier = useSelector((state) => state.register.uniqueID)
  const masterNumber = useSelector((state) => state.yourInformation.masterNumber)
  const emailAddress = useSelector((state) => state.yourInformation.emailAddress)
  const phoneNumber = useSelector((state) => state.yourInformation.phoneNumber)
  const isMasteNumberValid = useSelector((state) => state.masterNumberValidator.isMasteNumberValid)

  useEffect(() => {
    if (!isMasteNumberValid) {
      history.push(`/${i18n.language}${t('routes.your_info')}`)
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fulfillmentStatus = params.get('fulfillmentStatus')
    if (fulfillmentStatus === 'SENTFORPAYMENT') {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      let businessData = {}
      let yourInformation = {
        masterNumber,
        emailAddress,
        phoneNumber,
      }
      businessData['yourInformation'] = yourInformation
      let data = {}
      data['businessData'] = JSON.stringify(businessData)
      data['businessServiceType'] = 'PAYPRIVILEGEREINSTATEMENT'
      data['lang'] = i18n.language.toString()
      data['useridentifier'] = userIdentifier.toString()
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    try {
      if (confirmChecked) {
        setCheckboxMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            dispatch(screenLoadingAction())
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckboxMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const backNextProps = {
    prevText: t('review_confirmation.back'),
    prevURL: `/${i18n.language}${t('routes.your_info')}`,
    nextText: t('review_confirmation.proceed_to_payment'),
  }

  const checkNull = (val) => {
    return val === '' ? 'null' : val
  }

  return (
    <div className="container">
      <BackAnchor isInternal={true} backPath="routes.your_info" />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h1>{t('review_confirmation.verify_you_info')}</h1>
        </div>
      </div>
      {fulfillmentStatusError && (
        <div className="row">
          <div className="col-xs-12" style={{ display: 'flex' }}>
            <i
              className={['fa fa-exclamation-circle fa-2x', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            />
            <div className={styles['error_message']} style={{ marginLeft: '1rem' }}>
              <div className="form-group has-error">
                <div>
                  <h3 className="help-block">{t(fulfillmentStatusError)}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ display: 'inline-block' }}>{t('review_confirmation.contact_information')}</h3>
          <div className={[styles['edit-remove-btn']]}>
            <button
              className={['btn-xs btn-default', styles['edit_button_right']].join(' ')}
              onClick={() => history.push(`/${i18n.language}${t('routes.your_info')}`)}
              value={t('review_confirmation.edit')}
              name={t('review_confirmation.edit')}
            >
              {t('review_confirmation.edit')}
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className="row my-row row-odd">
            <div className="col-xs-6">
              <b>{t('review_confirmation.email_address')}</b>
            </div>
            <div className="col-xs-6">{emailAddress}</div>
          </div>
          <div className="row my-row row-even">
            <div className="col-xs-6">
              <b>{t('review_confirmation.phone_number')}</b>
            </div>
            <div className="col-xs-6">{checkNull(phoneNumber)}</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ display: 'inline-block' }}>{t('review_confirmation.fees_for_defaulted')}</h3>
          <div className={[styles['edit-remove-btn']]}>
            <button
              className={['btn-xs btn-default', styles['edit_button_right']].join(' ')}
              onClick={() => history.push(`/${i18n.language}${t('routes.your_info')}`)}
              value={t('review_confirmation.edit')}
              name={t('review_confirmation.edit')}
            >
              {t('review_confirmation.edit')}
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className="row my-row row-odd">
            <div className="col-xs-6">
              <b>{t('review_confirmation.master_number')}</b>
            </div>
            <div className="col-xs-6">{checkNull(masterNumber)}</div>
          </div>
          <div className="row my-row row-even">
            <div className="col-xs-6">
              <b>{t('review_confirmation.cost')}</b>
            </div>
            <div className="col-xs-6">{i18n.language === 'en' ? '$39.90' : '39,90 $'}</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h4 style={{ marginTop: '3em', marginBottom: '15px' }}>
            <b>{t('review_confirmation.confirmation')}</b>
          </h4>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          {t('review_confirmation.please_verify')}
          <br />
          {t('review_confirmation.your_confirmation')}
          <ul style={{ marginTop: '5px' }}>
            <li>{t('review_confirmation.you_consent_to')}</li>
            <li>
              {t('review_confirmation.you_are_in_agreement')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                    : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                }
              >
                {t('review_confirmation.terms_of_use')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              {t('review_confirmation.for_this_transaction')}
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className="ns-checkboxes__item">
            <input
              className="ns-checkboxes__input"
              type="checkbox"
              id="ConfirmationCheckBox"
              value="confirm_check"
              onChange={(e) => {
                setConfirmChecked(e.currentTarget.checked)
              }}
              onBlur={() => {
                confirmChecked ? setCheckboxMessage(false) : setCheckboxMessage(true)
              }}
              checked={confirmChecked}
            />
            <label className="ns-label ns-checkboxes__label confirm_check_input" htmlFor="ConfirmationCheckBox">
              <span className="ns-label-span">
                <b>{t('review_confirmation.yes_information_is_correct')}</b>
              </span>
            </label>
          </div>
          {checkboxMessage && (
            <div className="form-group has-error help-block">
              <i
                style={{ margin: '3px 5px 0 0' }}
                className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')}
                aria-hidden="true"
              ></i>
              {t('review_confirmation.confirm_check_error')}
            </div>
          )}
        </div>
      </div>
      <button className="btn-lg btn-success" onClick={confirmationClick}>
        {t('review_confirmation.proceed_to_payment')}
      </button>
      {errMsg !== '' && (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <div className="help-block">
              <i
                className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
                aria-hidden="true"
              />
              {t(errMsg)}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
